export const LIMITS = {
  name: { min: 2, max: 80 },
  email: { max: 160 },
  phone: { max: 32 },
  description: { min: 10, max: 4000 },
  budget: { max: 80 },
} as const;

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Loose but useful: digits, spaces, +, -, (), and an optional ext.
const PHONE_RE = /^[+()\d\s\-./xext]{6,32}$/i;

export type ContactInput = {
  name: string;
  email: string;
  phone?: string;
  description: string;
  budget: string;
  honeypot?: string;
};

export type ValidationResult =
  | { ok: true; data: ContactInput }
  | { ok: false; errors: Partial<Record<keyof ContactInput, string>> };

export function validateContact(input: unknown): ValidationResult {
  const errors: Partial<Record<keyof ContactInput, string>> = {};
  const v = (input ?? {}) as Record<string, unknown>;

  const name = String(v.name ?? '').trim();
  const email = String(v.email ?? '').trim().toLowerCase();
  const phoneRaw = String(v.phone ?? '').trim();
  const phone = phoneRaw === '' ? undefined : phoneRaw;
  const description = String(v.description ?? '').trim();
  const budget = String(v.budget ?? '').trim();
  const honeypot = String(v.honeypot ?? '');

  if (name.length < LIMITS.name.min || name.length > LIMITS.name.max) {
    errors.name = `Name must be ${LIMITS.name.min}–${LIMITS.name.max} characters.`;
  }
  if (!EMAIL_RE.test(email) || email.length > LIMITS.email.max) {
    errors.email = 'Please enter a valid email address.';
  }
  if (phone !== undefined && !PHONE_RE.test(phone)) {
    errors.phone = 'Phone number looks invalid.';
  }
  if (
    description.length < LIMITS.description.min ||
    description.length > LIMITS.description.max
  ) {
    errors.description = `Tell us a bit more (${LIMITS.description.min}–${LIMITS.description.max} characters).`;
  }
  if (budget.length === 0 || budget.length > LIMITS.budget.max) {
    errors.budget = 'Please give a rough budget.';
  }

  if (Object.keys(errors).length > 0) return { ok: false, errors };

  return {
    ok: true,
    data: { name, email, phone, description, budget, honeypot },
  };
}
